const numberFormats = {
  en: {
    currency: { style: 'currency', currency: 'USD' },
  },
  ja: {
    currency: { style: 'currency', currency: 'USD', currencyDisplay: 'symbol' },
  },
  ko: {
    currency: { style: 'currency', currency: 'USD', currencyDisplay: 'symbol' },
  },
  cs: {
    currency: { style: 'currency', currency: 'USD', currencyDisplay: 'symbol' },
  },
  fr: {
    currency: { style: 'currency', currency: 'USD', currencyDisplay: 'symbol' },
  },
  vi: {
    currency: { style: 'currency', currency: 'USD', currencyDisplay: 'symbol' },
  },
  pt: {
    currency: { style: 'currency', currency: 'USD', currencyDisplay: 'symbol' },
  },
  es: {
    currency: { style: 'currency', currency: 'USD', currencyDisplay: 'symbol' },
  },
  ar: {
    currency: { style: 'currency', currency: 'USD', currencyDisplay: 'symbol' },
  },
  it: {
    currency: { style: 'currency', currency: 'USD', currencyDisplay: 'symbol' },
  },
  de: {
    currency: { style: 'currency', currency: 'USD', currencyDisplay: 'symbol' },
  },
  hi: {
    currency: { style: 'currency', currency: 'USD', currencyDisplay: 'symbol' },
  },
  ru: {
    currency: { style: 'currency', currency: 'USD', currencyDisplay: 'symbol' },
  },
};

export default numberFormats;
